import { SET_SCHEMES_DATA_IN_STORE } from '../types';

export const setSchemesDataInStore = (data) => {
  return {
    type: SET_SCHEMES_DATA_IN_STORE,
    data,
  };
};
